import {
  MasonryCTACardRenderer,
  type MasonryCTACardRendererProps,
} from '@leagueplatform/masonry-renderers';

import { Box } from '@leagueplatform/genesis-core';

// This component is used to override the default masonry cta card renderer to ensure the image size is consistent across tablet, laptop, and desktop screen sizes. Tablet is resized by default in the masonry implementation.
export const CTACardRenderer = (props: MasonryCTACardRendererProps) => (
  <Box
    css={{
      '* > div:has(img)': {
        '@laptop': {
          maxWidth: 'var(--GDS--maxWidthDesktop)',
          maxHeight: 'var(--GDS--maxWidthDesktop)',
        },
        '@desktop': {
          maxWidth: 'var(--GDS--maxWidthDesktop)',
          maxHeight: 'var(--GDS--maxWidthDesktop)',
        },
      },
    }}
  >
    <MasonryCTACardRenderer
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  </Box>
);
